import { ToastProvider } from './components/ui/Toast/ToastProvider'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'

interface AppProvidersProps {
  children: React.ReactNode
}

const compose = (...providers: Array<React.ComponentType<AppProvidersProps>>) => {
  return providers.reduce(
    (AccumulatedProviders, CurrentProvider) => {
      const ComposedComponent = ({ children }: AppProvidersProps) => (
        <AccumulatedProviders>
          <CurrentProvider>{children}</CurrentProvider>
        </AccumulatedProviders>
      )
      ComposedComponent.displayName = `Composed(${
        CurrentProvider.displayName || CurrentProvider.name || 'Component'
      })`

      return ComposedComponent
    },
    ({ children }: AppProvidersProps) => <>{children}</>,
  )
}

export const AppProviders = compose(ToastProvider, ({ children }) => (
  <LocalizationProvider dateAdapter={AdapterDayjs}>{children}</LocalizationProvider>
))
